import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const EpisodeDetailsIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M3.92643753,1 L14.0710775,1 C14.8773935,1 15.6090029,1.32973944 16.1371012,1.85783776 C16.6677756,2.38851217 16.997515,3.12012156 16.997515,3.92643753 L16.997515,14.0710775 C16.997515,14.8773935 16.6677756,15.6090029 16.1371012,16.1371012 C15.6064268,16.6677756 14.8748174,16.997515 14.0710775,16.997515 L3.92643753,16.997515 C3.12012156,16.997515 2.38851217,16.6677756 1.85783776,16.1371012 C1.32973944,15.6090029 1,14.8773935 1,14.0710775 L1,3.92643753 C1,3.12269765 1.32973944,2.39108826 1.85783776,1.86041385 L1.85783776,1.85783776 C2.38851217,1.32973944 3.12012156,1 3.92643753,1 Z M5.45405853,5.9950373 L12.5434565,5.9950373 C12.8886525,5.9950373 13.1694462,5.71424356 13.1694462,5.36904758 C13.1694462,5.0264277 12.8886525,4.74563395 12.5434565,4.74563395 L5.45405853,4.74563395 C5.10886256,4.74563395 4.82806881,5.0264277 4.82806881,5.36904758 C4.82806881,5.71424356 5.10886256,5.9950373 5.45405853,5.9950373 Z M5.45405853,9.62217114 L8.99875751,9.62217114 C9.34395349,9.62217114 9.62217114,9.34395349 9.62217114,8.99875751 C9.62217114,8.65356154 9.34395349,8.37534388 8.99875751,8.37534388 L5.45405853,8.37534388 C5.10886256,8.37534388 4.82806881,8.65356154 4.82806881,8.99875751 C4.82806881,9.34395349 5.10886256,9.62217114 5.45405853,9.62217114 Z M5.45405853,13.2518811 L12.5434565,13.2518811 C12.8886525,13.2518811 13.1694462,12.9710873 13.1694462,12.6258914 C13.1694462,12.2832715 12.8886525,12.0024777 12.5434565,12.0024777 L5.45405853,12.0024777 C5.10886256,12.0024777 4.82806881,12.2832715 4.82806881,12.6258914 C4.82806881,12.9710873 5.10886256,13.2518811 5.45405853,13.2518811 Z"
        fill={fillColor}
      />
    </g>
  </svg>
);

EpisodeDetailsIcon.defaultProps = defaultProps;

export { EpisodeDetailsIcon };
